<script setup lang="ts">
import type { IProps } from './Lead.types'
defineProps<IProps>()
</script>

<template>
  <div class="corporateGovernanceMemberLead">
    <div class="corporateGovernanceMemberLead__container">

      <UiHeader
        :header="title"
        position="left"
        header-size="h5"
        header-size-tablet="h5"
        header-size-mobile="h5"
      />

      <p class="corporateGovernanceMemberLead__subtitle">
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.corporateGovernanceMemberLead {
  @include section-investor();
  padding-bottom:0;

  &__container {
    @include section-investor__container();
  }

  &__subtitle {
    @include h8;
    padding-bottom: 2.4rem;
    color: $text-400;
  }
}
</style>
